export const sellAllCategories = [
  'mostMomentum',
  'mostPopular',
  'mostRecent',
  'newest',
  'recentlyViewed',
  'closingSoon',
];

const categoryDisplayNames = {
  mostMomentum: 'Most Momentum',
  mostPopular: 'Most Funded',
  mostRecent: 'Most Recent',
  newest: 'Recently Launched',
  recentlyViewed: 'Recently Viewed',
  closingSoon: 'Closing Soon',
};

const categorySubtitles = {
  mostMomentum: 'Offerings that have raised the most money in the last few days',
  mostPopular: 'Offerings that have raised the most money so far',
  mostRecent: 'Most recently updated offerings',
  newest: 'Most recently launched offerings',
  recentlyViewed: 'Offerings that you have viewed but not invested in',
  closingSoon: 'Offerings that will be closing soon',
};

export const getCategoryTitle = (category) => {
  if (!category) return '';
  if (categoryDisplayNames[category]) return categoryDisplayNames[category];
  const title = category.replace(/([A-Z])/g, ' $1');
  return title.charAt(0).toUpperCase() + title.slice(1);
};

export const getCategorySubtitle = (category) => {
  if (!category) return '';
  return categorySubtitles[category] || '';
};
